/**
 * locale-cookie — persist the site-native locale next to localStorage.
 *
 * Shape (must match ichina / yok-zhang):
 *   locale=<code>; Path=/; Max-Age=31536000; SameSite=Lax
 *
 * Reads accept aliases via canonicalLocale so a leftover zh-Hans
 * cookie still resolves to `zh`. Writes always use site-native ids.
 */
import { LOCALE_COOKIE_KEY, type Locale } from './types.ts';
import { canonicalLocale } from './locale-detect.ts';

export function localeFromCookie(cookieHeader: string | null | undefined): Locale | null {
  if (!cookieHeader) return null;
  const match = cookieHeader.match(/(?:^|;\s*)locale=([^;]+)/);
  if (!match) return null;
  let value = match[1];
  try {
    value = decodeURIComponent(value);
  } catch {
    /* keep the raw token */
  }
  return canonicalLocale(value);
}

export function formatLocaleCookie(locale: Locale): string {
  return `${LOCALE_COOKIE_KEY}=${encodeURIComponent(locale)}; Path=/; Max-Age=31536000; SameSite=Lax`;
}

export function writeLocaleCookie(locale: Locale): void {
  if (typeof document === 'undefined') return;
  document.cookie = formatLocaleCookie(locale);
}
